export default {
  tab: {
    padding: {
      top: '1.125rem',
      right: '0.9375rem',
      bottom: '1.125rem',
      left: '0.9375rem',
    },
    border: {
      bottom: {
        style: 'solid',
        thickness: '0.0625rem',
      },
    },
    maxWidth: '15rem',
    content: {
      border: {
        style: 'solid',
        thickness: '0.0625rem',
      },
      padding: {
        top: '1.875rem',
        right: '1.875rem',
        bottom: '1.875rem',
        left: '1.875rem',
      },
    },
  },
};
